// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { fontConfig } from "@bg/XDL/PreStyle/typography";
import { ellipsis } from "@bg/XDL/Utilities";
import { BaseTheme } from "@insite/mobius/globals/baseTheme";
import * as React from "react";
import styled, { css, ThemeProps, withTheme } from "styled-components";

interface Props {
    /** used to accomplish line-clamp funcitonality */
    lineHeight?: number;
    /** any value < 1 is considred as no truncation */
    lines?: number;
}

const Truncated = styled.span<Props & ThemeProps<BaseTheme>>`
    ${props => css`
        line-height: ${props.lineHeight}px;
        ${ellipsis(2)}
    `};
`;

const Truncate: React.FC<Props & ThemeProps<BaseTheme>> = ({
    lineHeight = +fontConfig.lineHeight.regular,
    lines = 1,
    ...otherProps
}) => {
    return (
        <Truncated lines={lines} lineHeight={lineHeight}>
            {otherProps.children}
        </Truncated>
    );
};

export default withTheme(Truncate);
